import React, { PureComponent } from 'react';

class CabeceraRenglonModelo extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="seccionRenglonesModelo__cabeceraRenglonModelo">
                <div className="seccionRenglonesModelo__contenedorCabeceras seccionRenglonesModelo__contenedorTipoOperacion">
                    TIPO OPERACIÓN
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras seccionRenglonesModelo__contenedorNRenglon">
                    N° RENGLÓN
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras seccionRenglonesModelo__contenedorDescripcion">
                    DESCRIPCIÓN
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras seccionRenglonesModelo__contenedorCuentaContable">
                    CUENTA CONTABLE
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras seccionRenglonesModelo__contenedorTipoMovimiento">
                    TIPO MOVIMIENTO
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras seccionRenglonesModelo__contenedorCampo">
                    CAMPO
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras seccionRenglonesModelo__contenedorMoneda">
                    MONEDA
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras seccionRenglonesModelo__contenedorAccion">
                    ACCIÓN
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras seccionRenglonesModelo__contenedorFlecha">
                </div>
            </div>
        )
    }
}

export default CabeceraRenglonModelo;